import { Service } from "../../Model";
import { AdminBarberRepository } from "../../Repository";

export async function addService(
  service: Service,
  repository: AdminBarberRepository
): Promise<boolean> {
  return repository.addService(service);
}
